<template>
  <div class="vogue-mark"
    :class="{
      'mounted': mounted
    }"
  >
    <!-- 大于6个时，用swiper显示 -->
    <div
      class="vogue-home-mark-banner type-mark"
      :a="data.length"
      :class=" data.length > 6 ? 'd-block' : 'd-none d-md-block' "
    >
      <swiper
        class="swiper"
        :class=" data.length > 6 ? 'p-md-35' : '' "
        :options="swiperOption"
        ref="mark"
      >
        <swiper-slide class="stop-swiping" v-for="(list,index) in (data)" :key="index">
          <v-card :list="list" :is_flash="is_flash" @load="handleLoad" @error="handleError"></v-card>
        </swiper-slide>
      </swiper>
      <div class="d-none d-md-block">
        <div
          v-if="data.length>6"
          class="swiper-button-prev swiper-button-black"
          slot="button-prev"
        ></div>
        <div
          v-if="data.length>6"
          class="swiper-button-next swiper-button-black"
          slot="button-next"
        ></div>
      </div>
      <div class="swiper-pagination d-block d-md-none"></div>
    </div>
    
    <!-- 移动端 -->
    <div class="d-md-none d-block">
      <div v-if="data && data.length <= 6" class="row p-1-7d5">
        <div
          class="p-1-7d5"
          :class="{
            'col-6':　(index <　data.length -1 && (data.length % 2 > 0))||(data.length % 2 == 0),
            'col-12': index === data.length -1 && (data.length % 2 > 0),
            'p-0':no_spacing,
            'p-1-7d5':!no_spacing
          }"
          :style="no_spacing||index==data.length-1||index==data.length-2?'':'margin-bottom:15px'"
          v-for="(list,index) in (data)"
          :key="index"
        >
          <v-card :list="list" :is_flash="is_flash" @load="handleLoad" @error="handleError" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vCard from "./card";
export default {
  props: ["data", "no_spacing", "no_page","is_flash", 'skeletonClass'],
  data() {
    return {
      swiperOption: null,
      mounted: this.skeletonClass ? false : true,
    };
  },
  beforeMount() {
    const options = {
      spaceBetween: this.no_spacing ? 0 : 35,
      slidesPerView: this.data.length > 6 ? 6 : this.data.length,
      slidesPerGroup: 2,
      noSwiping: this.data.length > 6 ? false : true,
      noSwipingClass: "stop-swiping",
      //Swiper4.x版本为小于
      breakpoints: {
        768: {
          //当屏幕宽度小等于768
          spaceBetween: this.no_spacing ? 0 : 15,
          noSwiping: this.data.length > 2 ? false : true,
          slidesPerView: 2
        }
      },
      pagination: {
        el: ".type-mark .swiper-pagination"
      },
      navigation: {
        nextEl: ".type-mark .swiper-button-next",
        prevEl: ".type-mark .swiper-button-prev"
      }
    };

    this.swiperOption = options;
  },
  computed: {
    //获取swiper实例
    swiper() {
      return this.$refs.mark.swiper;
    }
  },
  components: {
    vCard
  },
  methods: {
    handleMounted() {
      if (this.mounted) return
      
      this.mounted = true;

      // 移除骨架屏
      const skeletonDom = document.querySelectorAll(`.${this.skeletonClass}`)

      if (skeletonDom) {
        // 删除所有元素
        Array.prototype.forEach.call(skeletonDom, (el) => {
          el.remove()
        })
      }
    },
    // 图片加载成功，即便是挂载成功
    handleLoad() {
      this.handleMounted()
    },
    // 图片加载失败，也表示挂载成功
    handleError() {
      this.handleMounted()
    }
  }
};
</script>
<style lang="scss" >
.vogue-mark {
  transition: all .2s;
  opacity: 0;
  height: 0;
  &.mounted {
    position: relative;
    z-index: 1;
    opacity: 1;
    height: auto;
  }
}
.vogue-home-mark-banner {
  position: relative;
  .swiper-slide {
    .product_item {
      margin-bottom: 0 !important;
    }
  }
  .swiper-pagination {
    position: unset;
    width: auto !important;
    margin: 15px auto;
    .swiper-pagination-bullet {
      width: 4px;
      height: 4px;
      margin: 0 5px;
    }
    .swiper-pagination-bullet-active {
      transition: width 0.5s;
      width: 34px;
      border-radius: 10px;
      background: #000;
    }
  }
  .swiper-button-prev,
  .swiper-button-next {
    top: 50%;
    height: 35px;
  }
  .swiper-button-prev {
    left: 5px;
  }
  .swiper-button-next {
    right: 5px;
  }
}
@media (max-width: 767px) {
  .vogue-home-mark-banner {
    // .swiper-slide {
    //   width: 50% !important;
    // }
    .swiper-button-prev,
    .swiper-button-next {
      height: 22px;
    }
    .swiper-button-prev {
      left: 0;
    }
    .swiper-button-next {
      right: 0;
    }
  }
}
@media (min-width: 768px) {
  .p-md-35 {
    padding: 0 35px;
  }
}
</style>